/**
 * Helpers for preparing numeric series before handing them to ApexCharts.
 *
 * ApexCharts builds SVG path strings directly from series values; a null,
 * NaN, or Infinity in the data produces a malformed path that crashes its
 * path parser ("parser Error" — Sentry HOLLYWOODTRUCKS-API-1).
 */

/** Replaces every non-finite value (null/undefined/NaN/±Infinity) with 0. */
export function sanitizeSeries(values: Array<number | null | undefined>): number[] {
  return values.map((value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  });
}
